import Component from '../site/Component';

/**
 * Component for showing Reader Reviews Module/LibraryThing
 */
export default class Print extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    this.printList();
  }

  printList() {
    const button = document.querySelector(this.elements.print);
    if (button) {
      button.addEventListener('click', () => {
        window.print();
      });
    }
  }
}
